import React from 'react';

const SupplierBasicInfo = ({ supplier }) => {
  return (
    <div className="detail-card">
      <div className="card-header">
        <h3>📋 Basic Information</h3>
      </div>
      <div className="card-content">
        <div className="info-row">
          <span className="info-label">Supplier ID</span>
          <span className="info-value">{supplier.id}</span>
        </div>
        <div className="info-row">
          <span className="info-label">Supplier Name</span>
          <span className="info-value">{supplier.supplier_name}</span>
        </div>
        <div className="info-row">
          <span className="info-label">Status</span>
          <span className="info-value">
            <span className={`status-badge ${supplier.status.toLowerCase()}`}>
              {supplier.status}
            </span>
          </span>
        </div>
        <div className="info-row">
          <span className="info-label">Is Few Shot</span>
          <span className="info-value">{supplier.isfewshot ? 'Yes' : 'No'}</span>
        </div>
      </div>
    </div>
  );
};

export default SupplierBasicInfo;
